var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.3,238.7c-25,0-46.3-8.9-64.1-26.7c-17.8-17.8-26.7-39.1-26.7-64.1s8.9-46.3,26.7-64.1 c17.8-17.8,39.1-26.7,64.1-26.7s46.3,8.9,64.1,26.7s26.7,39.1,26.7,64.1s-8.9,46.3-26.7,64.1S231.3,238.7,206.3,238.7z M24.9,420.1 v-63.5c0-12.5,3.2-24.2,9.6-35.2s15.3-19.3,26.7-25c19.3-9.8,41-18.1,65.2-25c24.2-6.8,50.9-10.2,80-10.2h7.9c2.3,0,4.5,0.4,6.8,1.1 c-3,6.8-5.6,13.9-7.7,21.3s-3.7,15-4.8,23h-2.3c-26.8,0-50.9,3.4-72.3,10.2c-21.4,6.8-38.8,13.6-52.5,20.4c-3.4,1.9-6.1,4.5-8.2,7.9 c-2.1,3.4-3.1,7.2-3.1,11.3v18.1h142.9c2.3,7.9,5.3,15.8,9.1,23.5s7.9,15,12.5,21.8H24.9z M342.4,442.8l-6.8-34 c-4.5-1.9-8.8-3.9-12.8-6s-8-4.6-12.2-7.7l-32.9,10.2l-22.7-38.6l26.1-22.7c-0.8-5.3-1.1-10.2-1.1-14.7c0-4.5,0.4-9.5,1.1-14.7 L255.1,292l22.7-38.6l32.9,10.2c4.2-3,8.2-5.6,12.2-7.7c4-2.1,8.2-4.1,12.8-6l6.8-34h45.4l6.8,34c4.5,1.9,8.8,4,12.8,6.2 c4,2.3,8,5.1,12.2,8.5l32.9-11.3l22.7,39.7l-26.1,22.7c0.8,4.5,1.1,9.3,1.1,14.2s-0.4,9.6-1.1,14.2l26.1,22.7l-22.7,38.6l-32.9-10.2 c-4.2,3-8.2,5.6-12.2,7.7c-4,2.1-8.2,4.1-12.8,6l-6.8,34H342.4z M365.1,374.8c12.5,0,23.2-4.4,32-13.3c8.9-8.9,13.3-19.6,13.3-32 c0-12.5-4.4-23.2-13.3-32c-8.9-8.9-19.6-13.3-32-13.3s-23.2,4.4-32,13.3c-8.9,8.9-13.3,19.6-13.3,32c0,12.5,4.4,23.2,13.3,32 C342,370.3,352.6,374.8,365.1,374.8z M206.3,193.3c12.5,0,23.2-4.4,32-13.3c8.9-8.9,13.3-19.6,13.3-32c0-12.5-4.4-23.2-13.3-32 s-19.6-13.3-32-13.3c-12.5,0-23.2,4.4-32,13.3c-8.9,8.9-13.3,19.6-13.3,32c0,12.5,4.4,23.2,13.3,32 C183.2,188.8,193.9,193.3,206.3,193.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanel);
export default __webpack_public_path__ + "static/media/admin_panel.68b36826d5a7673d247051d7ec2cf120.svg";
export { ForwardRef as ReactComponent };